module.exports = __webpack_public_path__ + "common.svg?325eaa97ccde9cdfbfcc294f8daf77e8";